var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('div',[_vm._v(_vm._s(_vm.error))]):_c('div',{staticClass:"patient"},[_c('span',[_c('b',[_vm._v("Пациент:")]),_vm._v(" "+_vm._s(_vm.patient.name))]),_c('span',[_c('b',[_vm._v("Телефон:")]),_vm._v(" "+_vm._s(_vm.patient.phone))]),_c('span',[_c('b',[_vm._v("Email:")]),_vm._v(" "+_vm._s(_vm.patient.email))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }